<template>
  <header class="header_wrp">
    <div class="container-fluid">
      <div class="header_main_wrp">
        <div class="row align-items-center">
          <div class="col-12">
            <div class="logo-wrp">
              <img
                class="img-fluid"
                src="https://res.cloudinary.com/ilovekickboxing/image/upload/f_auto,fl_lossy,q_auto:eco/v1/Brand/logo-main-white-1.png"
                alt="iLoveKickboxing Logo"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>